import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'login',
    component:  () => import('../views/login.vue'),
    meta: { title: '资料库登录', icon: 'dashboard' }
  },
  {
    path: '/amend-password',
    name: 'amendpassword',
    component:  () => import('../views/amend-password.vue'),
    meta: { title: '修改密码', icon: 'dashboard' }
  }
]






const router = new VueRouter({
  routes
})





/**
 * 路由拦截
 * 权限验证
 */
 router.beforeEach(async (to,from, next ) => {
  //  
  // 进度条
  // NProgress.start()
  // 验证当前路由所有的匹配中是否需要有登录验证的
  // to.matched.some(r => r.meta.auth)
  if (to.path != '/login') {
    // 这里暂时将cookie里是否存有token作为验证是否登录的条件
    // 请根据自身业务需要修改
     let token = localStorage.getItem("token");
    
    // const token = getCookie('token')
    // const organ = getCookie('organ')
    if (token && token !== 'undefined') {
      next()
    } else {
      // 没有登录的时候跳转到登录界面
      // 携带上登陆成功之后需要跳转的页面完整路径
        localStorage.setItem('token','')

      next({
        path: '/login'
        // query: {
        //   redirect: to.fullPath
        // }
      })
    }
  } else {
    // 不需要身份校验 直接通过
    next()
  }
})




export default router
